import '../../../utils/index2.mjs';
import { buildProps } from '../../../utils/vue/props/runtime2.mjs';

const badgeProps = buildProps({
  value: {
    type: [String, Number],
    default: ""
  },
  max: {
    type: Number,
    default: 99
  },
  isDot: Boolean,
  hidden: Boolean,
  type: {
    type: String,
    values: ["primary", "success", "warning", "info", "danger"],
    default: "danger"
  }
});

export { badgeProps };
//# sourceMappingURL=badge3.mjs.map
